import apiClient from '@/services/axios'

export const put = async (id, mediaspaceAd) => {
    const response = await apiClient.put(`/mediaspace/${id}`, mediaspaceAd)
    return response.data
} 